import {
  BoxCenterStart,
  BoxFlexStartTop,
} from '../style/box'
import '../style/legend_risk.css';
import '../style/legend_map.css';
import {
  CHRONOLOGY_CATEGORY_NAME,
  RAIN_COLOR,
  RISK_COLOR,
  RAIN_H1_LEVEL_POINT,
  RAIN_H24_LEVEL_POINT,
  RAIN_H48_LEVEL_POINT,
  SR_RISK_COLOR,
  TYPHOON_COLOR,
  TYPHOON_LEVEL_POINT,
  RIVER_RISK,
  OF_VAL_LEVEL,
} from '../const/color'
import CircleIcon from "@mui/icons-material/Circle";
import SquareIcon from '@mui/icons-material/Square';
import { RISK_ANALYSIS_LAYER_KEY } from '../const/map_config'
import { Box, Typography } from '@mui/material';
import { Fragment } from 'react';

export const SOIL_RISK_H1_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="h1_rain">1時間雨量</li>
      <li className="soil_risk1" style={{ paddingLeft: '15px' }}>通常</li>
      <li className="soil_risk2">注意</li>
      <li className="soil_risk3">警戒</li>
      <li className="soil_risk4">厳重警戒</li>
      <li className="soil_risk5">危険</li>
    </ul>
  </BoxCenterStart>
  )
}

export const BSN_DISCHARGE_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="bsn_discharge5">氾濫危険水位</li>
      <li className="bsn_discharge4">避難判断水位</li>
      <li className="bsn_discharge3">氾濫注意水位</li>
      <li className="bsn_discharge2">水防団待機水位</li>
      <li className="bsn_discharge1">平常</li>
      <li className="bsn_discharge0">欠測</li>
    </ul>
  </BoxCenterStart>
  )
}

export const RISK_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="risk1">レベル1</li>
      <li className="risk2">レベル2</li>
      <li className="risk3">レベル3</li>
      <li className="risk4">レベル4</li>
      <li className="risk5">レベル5</li>
    </ul>
  </BoxCenterStart>
  )
}

export const RIVER_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="river_purple">氾濫危険水位</li>
      <li className="river_red">避難判断水位</li>
      <li className="river_yellow">氾濫注意水位</li>
      <li className="river_green">水防団待機水位</li>
      <li className="river_lightblue">平常</li>
      <li className="river_gray">欠測</li>
    </ul>
  </BoxCenterStart>
  )
}

const CHRONOLOGY_LEGEND_LIST = (cat) => {
  switch (cat) {
    case CHRONOLOGY_CATEGORY_NAME.COLLAPSE:
      return <li className="chronology_collapse">{CHRONOLOGY_CATEGORY_NAME.COLLAPSE}</li>
    case CHRONOLOGY_CATEGORY_NAME.WATERLV:
      return <li className="chronology_waterlv">{CHRONOLOGY_CATEGORY_NAME.WATERLV}</li>
    case CHRONOLOGY_CATEGORY_NAME.CAVE_IN:
      return <li className="chronology_cave_in">{CHRONOLOGY_CATEGORY_NAME.CAVE_IN}</li>
    case CHRONOLOGY_CATEGORY_NAME.ROAD:
      return <li className="chronology_road">{CHRONOLOGY_CATEGORY_NAME.ROAD}</li>
    case CHRONOLOGY_CATEGORY_NAME.FLOOD:
      return <li className="chronology_flood">{CHRONOLOGY_CATEGORY_NAME.FLOOD}</li>
    case CHRONOLOGY_CATEGORY_NAME.WATER_CHANNEL:
      return <li className="chronology_water_channel">{CHRONOLOGY_CATEGORY_NAME.WATER_CHANNEL}</li>
    case CHRONOLOGY_CATEGORY_NAME.POWER_OUTAGE:
      return <li className="chronology_power_outage">{CHRONOLOGY_CATEGORY_NAME.POWER_OUTAGE}</li>
    case CHRONOLOGY_CATEGORY_NAME.WATER_OUTAGE:
      return <li className="chronology_water_outage">{CHRONOLOGY_CATEGORY_NAME.WATER_OUTAGE}</li>
    case CHRONOLOGY_CATEGORY_NAME.GAS:
      return <li className="chronology_gas">{CHRONOLOGY_CATEGORY_NAME.GAS}</li>
    case CHRONOLOGY_CATEGORY_NAME.COMMUNICATION:
      return <li className="chronology_communication">{CHRONOLOGY_CATEGORY_NAME.COMMUNICATION}</li>
    case CHRONOLOGY_CATEGORY_NAME.WIND_LIGNTNING:
      return <li className="chronology_wind_ligntning">{CHRONOLOGY_CATEGORY_NAME.WIND_LIGNTNING}</li>
    case CHRONOLOGY_CATEGORY_NAME.FIRE:
      return <li className="chronology_fire">{CHRONOLOGY_CATEGORY_NAME.FIRE}</li>
    case CHRONOLOGY_CATEGORY_NAME.TSUNAMI:
      return <li className="chronology_tsunami">{CHRONOLOGY_CATEGORY_NAME.TSUNAMI}</li>
    default:
      return <></>
  }
}

export const CHRONOLOGY_LEGEND = (cat_name_arry) => {
  return (
    <BoxCenterStart >
      <ul className='risk'>
        {cat_name_arry.map((cat) => {
          return CHRONOLOGY_LEGEND_LIST(cat)
        })}
      </ul>
    </BoxCenterStart>
  )
}

export const HAZERD_FLOOD_LEGEND = () => {
  return (<BoxFlexStartTop >
    <ul className='map'>
      <li className="hazard_flood6">20m〜</li>
      <li className="hazard_flood5">10〜20m</li>
      <li className="hazard_flood4">5.0〜10m</li>
      <li className="hazard_flood3">3.0〜5.0m</li>
      <li className="hazard_flood2">0.5〜3.0m</li>
      <li className="hazard_flood1">0.0〜0.5m</li>
    </ul>
  </BoxFlexStartTop>
  )
}

export const HAZERD_INLAND_FLOOD_LEGEND = () => {
  return (<BoxFlexStartTop >
    <ul className='map'>
      <li className="hazard_inland_flood4">1.0〜2.0m</li>
      <li className="hazard_inland_flood3">0.45〜1.0m</li>
      <li className="hazard_inland_flood2">0.3〜0.45m</li>
      <li className="hazard_inland_flood1">0.1〜0.3m</li>
    </ul>
  </BoxFlexStartTop>
  )
}

export const HAZERD_LANDSLIDE_LEGEND = () => {
  return (<BoxFlexStartTop >
    <ul className='map'>
      <li className="hazard_landslide2">特別警戒区域</li>
      <li className="hazard_landslide1">警戒区域</li>
    </ul>
  </BoxFlexStartTop>
  )
}

export const CHRONOLOGY_MAP_LEGEND = () => {
  return (<BoxFlexStartTop >
    <ul className='risk'>
      <li className="chronology_hight">高</li>
      <li className="chronology_middle">中</li>
      <li className="chronology_low">低</li>
    </ul>
  </BoxFlexStartTop>
  )
}

export const CHRONOLOGY_PUBLIC_MAP_LEGEND = () => {
  return (<BoxFlexStartTop >
    <ul className='map'>
      <li className="chronology_low">市民からの被害報告</li>
    </ul>
  </BoxFlexStartTop>
  )
}

export const WAREHOUSES_DISASTER_MAP_LEGEND = () => {
  return (<BoxFlexStartTop >
    <ul className='map'>
      <li className="warehouses-disaster">防災倉庫</li>
    </ul>
  </BoxFlexStartTop>
  )
}

export const WAREHOUSES_STOCK_MAP_LEGEND = () => {
  return (<BoxFlexStartTop >
    <ul className='map'>
      <li className="warehouses-stock">備蓄場所</li>
    </ul>
  </BoxFlexStartTop>
  )
}

export const RISK_LEGEND_ITEMS = [
  { label: RISK_COLOR.LEVEL_5.label, color: RISK_COLOR.LEVEL_5.color, font_color: RISK_COLOR.LEVEL_5.font_color },
  { label: RISK_COLOR.LEVEL_4.label, color: RISK_COLOR.LEVEL_4.color, font_color: RISK_COLOR.LEVEL_4.font_color },
  { label: RISK_COLOR.LEVEL_3.label, color: RISK_COLOR.LEVEL_3.color, font_color: RISK_COLOR.LEVEL_3.font_color },
  { label: RISK_COLOR.LEVEL_2.label, color: RISK_COLOR.LEVEL_2.color, font_color: RISK_COLOR.LEVEL_2.font_color },
  { label: RISK_COLOR.LEVEL_1.label, color: RISK_COLOR.LEVEL_1.color, font_color: RISK_COLOR.LEVEL_1.font_color },
];

export const RAIN_H1_LEGEND_ITEMS = [
  { label: `${RAIN_H1_LEVEL_POINT.LEVEL_7} 〜`, color: RAIN_COLOR.LEVEL_8.color, font_color: RAIN_COLOR.LEVEL_8.font_color },
  { label: `${RAIN_H1_LEVEL_POINT.LEVEL_6} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_7}`, color: RAIN_COLOR.LEVEL_7.color, font_color: RAIN_COLOR.LEVEL_7.font_color },
  { label: `${RAIN_H1_LEVEL_POINT.LEVEL_5} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_6}`, color: RAIN_COLOR.LEVEL_6.color, font_color: RAIN_COLOR.LEVEL_6.font_color },
  { label: `${RAIN_H1_LEVEL_POINT.LEVEL_4} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_5}`, color: RAIN_COLOR.LEVEL_5.color, font_color: RAIN_COLOR.LEVEL_5.font_color },
  { label: `${RAIN_H1_LEVEL_POINT.LEVEL_3} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_4}`, color: RAIN_COLOR.LEVEL_4.color, font_color: RAIN_COLOR.LEVEL_4.font_color },
  { label: `${RAIN_H1_LEVEL_POINT.LEVEL_2} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_3}`, color: RAIN_COLOR.LEVEL_3.color, font_color: RAIN_COLOR.LEVEL_3.font_color },
  { label: `${RAIN_H1_LEVEL_POINT.LEVEL_1} 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_2}`, color: RAIN_COLOR.LEVEL_2.color, font_color: RAIN_COLOR.LEVEL_2.font_color },
  { label: ` 〜 ${RAIN_H1_LEVEL_POINT.LEVEL_1}`, color: RAIN_COLOR.LEVEL_1.color, font_color: RAIN_COLOR.LEVEL_1.font_color },
];

export const RAIN_H24_LEGEND_ITEMS = [
  { label: `${RAIN_H24_LEVEL_POINT.LEVEL_7} 〜`, color: RAIN_COLOR.LEVEL_8.color, font_color: RAIN_COLOR.LEVEL_8.font_color },
  { label: `${RAIN_H24_LEVEL_POINT.LEVEL_6} 〜 ${RAIN_H24_LEVEL_POINT.LEVEL_7}`, color: RAIN_COLOR.LEVEL_7.color, font_color: RAIN_COLOR.LEVEL_7.font_color },
  { label: `${RAIN_H24_LEVEL_POINT.LEVEL_5} 〜 ${RAIN_H24_LEVEL_POINT.LEVEL_6}`, color: RAIN_COLOR.LEVEL_6.color, font_color: RAIN_COLOR.LEVEL_6.font_color },
  { label: `${RAIN_H24_LEVEL_POINT.LEVEL_4} 〜 ${RAIN_H24_LEVEL_POINT.LEVEL_5}`, color: RAIN_COLOR.LEVEL_5.color, font_color: RAIN_COLOR.LEVEL_5.font_color },
  { label: `${RAIN_H24_LEVEL_POINT.LEVEL_3} 〜 ${RAIN_H24_LEVEL_POINT.LEVEL_4}`, color: RAIN_COLOR.LEVEL_4.color, font_color: RAIN_COLOR.LEVEL_4.font_color },
  { label: `${RAIN_H24_LEVEL_POINT.LEVEL_2} 〜 ${RAIN_H24_LEVEL_POINT.LEVEL_3}`, color: RAIN_COLOR.LEVEL_3.color, font_color: RAIN_COLOR.LEVEL_3.font_color },
  { label: `${RAIN_H24_LEVEL_POINT.LEVEL_1} 〜 ${RAIN_H24_LEVEL_POINT.LEVEL_2}`, color: RAIN_COLOR.LEVEL_2.color, font_color: RAIN_COLOR.LEVEL_2.font_color },
  { label: ` 〜 ${RAIN_H24_LEVEL_POINT.LEVEL_1}`, color: RAIN_COLOR.LEVEL_1.color, font_color: RAIN_COLOR.LEVEL_1.font_color },
];

export const RAIN_H48_LEGEND_ITEMS = [
  { label: `${RAIN_H48_LEVEL_POINT.LEVEL_7} 〜`, color: RAIN_COLOR.LEVEL_8.color, font_color: RAIN_COLOR.LEVEL_8.font_color },
  { label: `${RAIN_H48_LEVEL_POINT.LEVEL_6} 〜 ${RAIN_H48_LEVEL_POINT.LEVEL_7}`, color: RAIN_COLOR.LEVEL_7.color, font_color: RAIN_COLOR.LEVEL_7.font_color },
  { label: `${RAIN_H48_LEVEL_POINT.LEVEL_5} 〜 ${RAIN_H48_LEVEL_POINT.LEVEL_6}`, color: RAIN_COLOR.LEVEL_6.color, font_color: RAIN_COLOR.LEVEL_6.font_color },
  { label: `${RAIN_H48_LEVEL_POINT.LEVEL_4} 〜 ${RAIN_H48_LEVEL_POINT.LEVEL_5}`, color: RAIN_COLOR.LEVEL_5.color, font_color: RAIN_COLOR.LEVEL_5.font_color },
  { label: `${RAIN_H48_LEVEL_POINT.LEVEL_3} 〜 ${RAIN_H48_LEVEL_POINT.LEVEL_4}`, color: RAIN_COLOR.LEVEL_4.color, font_color: RAIN_COLOR.LEVEL_4.font_color },
  { label: `${RAIN_H48_LEVEL_POINT.LEVEL_2} 〜 ${RAIN_H48_LEVEL_POINT.LEVEL_3}`, color: RAIN_COLOR.LEVEL_3.color, font_color: RAIN_COLOR.LEVEL_3.font_color },
  { label: `${RAIN_H48_LEVEL_POINT.LEVEL_1} 〜 ${RAIN_H48_LEVEL_POINT.LEVEL_2}`, color: RAIN_COLOR.LEVEL_2.color, font_color: RAIN_COLOR.LEVEL_2.font_color },
  { label: ` 〜 ${RAIN_H48_LEVEL_POINT.LEVEL_1}`, color: RAIN_COLOR.LEVEL_1.color, font_color: RAIN_COLOR.LEVEL_1.font_color },
];

export const SOIL_RAIN_LEGEND_ITEMS = [
  { label: SR_RISK_COLOR.LEVEL_5.label, color: SR_RISK_COLOR.LEVEL_5.color, font_color: SR_RISK_COLOR.LEVEL_5.font_color },
  { label: SR_RISK_COLOR.LEVEL_4.label, color: SR_RISK_COLOR.LEVEL_4.color, font_color: SR_RISK_COLOR.LEVEL_4.font_color },
  { label: SR_RISK_COLOR.LEVEL_3.label, color: SR_RISK_COLOR.LEVEL_3.color, font_color: SR_RISK_COLOR.LEVEL_3.font_color },
  { label: SR_RISK_COLOR.LEVEL_2.label, color: SR_RISK_COLOR.LEVEL_2.color, font_color: SR_RISK_COLOR.LEVEL_2.font_color },
  { label: SR_RISK_COLOR.LEVEL_1.label, color: SR_RISK_COLOR.LEVEL_1.color, font_color: SR_RISK_COLOR.LEVEL_1.font_color },
];

export const TYPHOON_LEGEND_ITEMS = [
  { label: `${TYPHOON_LEVEL_POINT.LEVEL_3} % 〜 ${TYPHOON_LEVEL_POINT.LEVEL_4} %`, color: TYPHOON_COLOR.LEVEL_4.color, font_color: TYPHOON_COLOR.LEVEL_4.font_color },
  { label: `${TYPHOON_LEVEL_POINT.LEVEL_2} % 〜 ${TYPHOON_LEVEL_POINT.LEVEL_3} %`, color: TYPHOON_COLOR.LEVEL_3.color, font_color: TYPHOON_COLOR.LEVEL_3.font_color },
  { label: `${TYPHOON_LEVEL_POINT.LEVEL_1} % 〜 ${TYPHOON_LEVEL_POINT.LEVEL_2} %`, color: TYPHOON_COLOR.LEVEL_2.color, font_color: TYPHOON_COLOR.LEVEL_2.font_color },
  { label: `0 %`, color: TYPHOON_COLOR.LEVEL_1.color, font_color: TYPHOON_COLOR.LEVEL_1.font_color },
];

export const RIVER_LEVEL_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="river_level">河川水位(m)</li>
    </ul>
  </BoxCenterStart>
  )
}

export const BSN_AVERAGE_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="bsn_average24h">流域平均24時間雨量</li>
      <li className="bsn_average">流域平均流出量</li>
    </ul>
  </BoxCenterStart>
  )
}

export const getLegendItem = (selectLayer) => {
  switch (selectLayer) {
    case RISK_ANALYSIS_LAYER_KEY.MSH_H1:
    case RISK_ANALYSIS_LAYER_KEY.BSN_H1:
      return RAIN_H1_LEGEND_ITEMS;
    case RISK_ANALYSIS_LAYER_KEY.MSH_H24:
    case RISK_ANALYSIS_LAYER_KEY.BSN_H24:
      return RAIN_H24_LEGEND_ITEMS;
    case RISK_ANALYSIS_LAYER_KEY.MSH_H48:
    case RISK_ANALYSIS_LAYER_KEY.BSN_H48:
      return RAIN_H48_LEGEND_ITEMS;
    case RISK_ANALYSIS_LAYER_KEY.MSH_RISK:
    case RISK_ANALYSIS_LAYER_KEY.MSH_SOIL:
    case RISK_ANALYSIS_LAYER_KEY.BSN_OF:
      return RISK_LEGEND_ITEMS;
    default:
      return RAIN_H1_LEGEND_ITEMS;
  }
};

export const H1_RAIN_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="h1_rain_risk">1時間雨量</li>
      <li className="h1_rain1" style={{ paddingLeft: '15px' }}>基準未満</li>
      <li className="h1_rain2">強い雨</li>
      <li className="h1_rain3">激しい雨</li>
      <li className="h1_rain4">非常に激しい雨</li>
      <li className="h1_rain5">猛烈な雨</li>
    </ul>
  </BoxCenterStart>
  )
}

export const H1_RISK_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="soil_risk1">平常</li>
      <li className="soil_risk2">注意報相当</li>
      <li className="soil_risk3">警報相当</li>
      <li className="soil_risk4">警報(土砂)相当 </li>
      <li className="soil_risk5">特別警報相当 </li>
    </ul>
  </BoxCenterStart>
  )
}

export const H1_AREA_RISK_LEGEND = () => {
  return (<BoxCenterStart >
    <ul className='risk'>
      <li className="h1_rain">1時間雨量</li>
      <li className="h1_circle">土砂災害発生リスク</li>
      <li className="area_risk1">レベル0</li>
      <li className="area_risk2">レベル1</li>
      <li className="area_risk3">レベル2</li>
      <li className="area_risk4">レベル3 </li>
      <li className="area_risk5">レベル4 </li>
    </ul>
  </BoxCenterStart>
  )
}

export const SHELTER_ANARYSIS_HDCNT_LEGEND = () => {
  return (
    <BoxCenterStart >
      <ul className='risk'>
        <li className="shelter_analysis2">増加</li>
        <li className="shelter_analysis1">減少</li>
      </ul>
    </BoxCenterStart>
  )
}

export const SHELTER_ANARYSIS_TREEMAP_LEGEND = () => {
  return (
    <BoxCenterStart >
      <ul className='risk'>
        <li className="shelter_analysis_treemap1">0人</li>
        <li className="shelter_analysis_treemap2">1〜10人</li>
        <li className="shelter_analysis_treemap4">50~100人</li>
        <li className="shelter_analysis_treemap3">10〜50人</li>
        <li className="shelter_analysis_treemap5">100人〜</li>
      </ul>
    </BoxCenterStart>
  )
}

export const RIVER_BSN_TEL_LEGEND = () => {
  return (
    <BoxCenterStart sx={{ flexDirection: 'column' }}>
      <Box sx={{ width: '100%', minHeight: '20px', display: 'flex', alignItems: 'center', padding: '2px 10px', flexWrap: 'wrap' }}>
        <Typography
          variant="body2"
          sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'white', marginRight: '10px' }}
        >
          水位危険度:
        </Typography>
        {[...RIVER_RISK].sort((a, b) => b.max - a.max).map((item) => (
          <Fragment key={item.max}>
            <CircleIcon sx={{ color: item.color, fontSize: '12px' }} />
            <Typography
              variant="body2"
              sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'white', marginRight: '10px' }}
            >
              {item.label}
            </Typography>
          </Fragment>
        ))}
      </Box>
      <Box sx={{ width: '100%', minHeight: '20px', display: 'flex', alignItems: 'center', padding: '2px 10px', flexWrap: 'wrap' }}>
        <Typography
          variant="body2"
          sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'white', marginRight: '10px' }}
        >
          流出量差:
        </Typography>
        {OF_VAL_LEVEL.map((item) => (
          <Fragment key={item.max}>
            <SquareIcon sx={{ color: item.color, fontSize: '12px' }} />
            <Typography
              variant="body2"
              sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'white', marginRight: '10px' }}
            >
              {item.label}
            </Typography>
          </Fragment>
        ))}
      </Box>
    </BoxCenterStart>
  )
}

export const CHRONOLOGY_VERTICAL_BAR_STACK_LEGEND = () => {
  // 表示領域の最大高さ（必要に応じて調整）
  const MAX_HEIGHT = '60px';
  return (
    <BoxCenterStart >
      <div style={{ width: '100%', maxHeight: MAX_HEIGHT, overflowY: 'auto' }}>
        <ul className='risk chronology-center' style={{ margin: 0, padding: 0 }}>
          <li class="chronology_vertical_bar_stack1">決壊</li>
          <li class="chronology_vertical_bar_stack2">その他被害</li>
          <li class="chronology_vertical_bar_stack3">交通規制</li>
          <li class="chronology_vertical_bar_stack4">停電・断線</li>
          <li class="chronology_vertical_bar_stack5">断水・破断</li>
          <li class="chronology_vertical_bar_stack6">崩壊・損傷</li>
          <li class="chronology_vertical_bar_stack7">倒木</li>
          <li class="chronology_vertical_bar_stack8">冠水・浸水</li>
          <li class="chronology_vertical_bar_stack9">土砂崩れ</li>
        </ul>
      </div>
    </BoxCenterStart>
  )
}

export const TREND_PIVOT_VERTICAL_BAR_STACK_LEGEND = () => {
  // 表示領域の最大高さ（必要に応じて調整）
  const MAX_HEIGHT = '100px';
  return (
    <BoxCenterStart >
      <div style={{ width: '100%', maxHeight: MAX_HEIGHT, overflowY: 'auto' }}>
        <ul className='risk trend-pivot-center' style={{ margin: 0, padding: 0 }}>
          <li class="trend_pivot_vertical_bar_stack1">A群溶血性レンサ球菌咽頭炎</li>
          <li class="trend_pivot_vertical_bar_stack2">細菌性髄膜炎</li>
          <li class="trend_pivot_vertical_bar_stack3">突発性発疹</li>
          <li class="trend_pivot_vertical_bar_stack4">無菌性髄膜炎</li>
          <li class="trend_pivot_vertical_bar_stack5">流行性結膜炎</li>
          <li class="trend_pivot_vertical_bar_stack6">水痘</li>
          <li class="trend_pivot_vertical_bar_stack7">感染性胃腸炎</li>
          <li class="trend_pivot_vertical_bar_stack8">手足口病</li>
          <li class="trend_pivot_vertical_bar_stack9">急性出血性結膜炎</li>
          <li class="trend_pivot_vertical_bar_stack10">伝染性紅斑</li>
          <li class="trend_pivot_vertical_bar_stack11">咽頭結膜熱</li>
          <li class="trend_pivot_vertical_bar_stack12">ロタウイルス</li>
          <li class="trend_pivot_vertical_bar_stack13">ムンプス</li>
          <li class="trend_pivot_vertical_bar_stack14">ヘルパンギーナ</li>
          <li class="trend_pivot_vertical_bar_stack15">クラミジア肺炎</li>
          <li class="trend_pivot_vertical_bar_stack16">RSウイルス</li>
          <li class="trend_pivot_vertical_bar_stack17">小児マイコプラズマ肺炎</li>
          <li class="trend_pivot_vertical_bar_stack18">マイコプラズマ肺炎</li>
          <li class="trend_pivot_vertical_bar_stack19">インフルエンザ</li>
          <li class="trend_pivot_vertical_bar_stack20">COVID-19</li>
        </ul>
      </div>
    </BoxCenterStart>
  )
}